module.exports = __webpack_public_path__ + "static/confidentiality_policy.82d354e5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/policies/confidentiality_policy.pdf
// module id = 327
// module chunks = 177890977751730